module.exports = __webpack_public_path__ + "img/emergency-skin.80c72baf.png";